// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"22db2c2f","143":"d4fe2632","424":"c4b2abdf","494":"387abd88","533":"d4814aaf","651":"24be0f73","690":"d025b443","852":"7322d2fb","940":"c6d3df0f"}[chunkId] + ".chunk.js";
};